import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'saving-in-progress',
  templateUrl: './saving-in-progress.component.html',
  styleUrls: ['./saving-in-progress.component.scss'],
})
export class SavingInProgressComponent implements OnInit {
  message: String = 'Saving in progress...';
  @Input() showSavingInProgress: boolean;
  @Input() inProgressMessage: string;

  constructor() {}
  ngOnInit() {
    if (this.inProgressMessage) {
      this.message = this.inProgressMessage;
    }
  }
}
